import { render, staticRenderFns } from "./ViewRecords.vue?vue&type=template&id=7a2d6d2c"
import script from "./ViewRecords.vue?vue&type=script&lang=js"
export * from "./ViewRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports